import $foreign from "./foreign.cjs";
var arrayBind = $foreign.arrayBind;
export { arrayBind };
